<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 承包商模板配置
-->
<template>
  <el-card class="h-full">
    <div class="w-full h-full">
      <div class="flex mb-20px mr-20px">
        <div>
          <el-input
            size="small"
            class="mr-10px !w-50"
            placeholder="请输入模板名称"
            v-model="searchData.templateName"
            clearable
          ></el-input>
          <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
          <el-button
            size="small"
            type="primary"
            @click="handleAdd()"
            :disabled="!$hasAccess('create')"
            >新增</el-button
          >
        </div>
      </div>
      <el-table :data="dataList" border :height="tableHeight" stripe v-loading="tableLoading">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="模板名称"
          prop="templateName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="创建人"
          prop="operatorName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="创建时间" prop="creationTime" width="260" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" :disabled="!$hasAccess('update')"
              >编辑</el-button
            >
            <el-button size="mini" @click="handleDel(scope.row)" :disabled="!$hasAccess('delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="tableSizeChange"
        @current-change="tableCurrentChange"
        :current-page.sync="pageConfig.SkipCount"
        :page-size.sync="pageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="totalCount"
        class="float-right mt-20px ml-20px"
      ></el-pagination>
    </div>

    <!-- 模板新增 -->
    <el-dialog
      v-if="dialogShow"
      :close-on-click-modal="false"
      :title="pageType === 'create' ? '新增模板' : pageType === 'update' ? '编辑模板' : '模板详情'"
      :visible.sync="dialogShow"
      width="1330px"
      v-dialogDrag
    >
      <template-form
        :FormData="FormData"
        :pageType="pageType"
        @save="handleSave"
        @cancel="dialogShow = false"
      ></template-form>
    </el-dialog>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import {
  ProfileTemplateConfigurationApi,
  ProfileTemplateGuidanceConfigurationApi,
} from '@wiz-api/contractor-management'
import TemplateForm from '../components/TemplateForm'

const profileTemplateConfigurationApi = new ProfileTemplateConfigurationApi()
const profileTemplateGuidanceConfigurationApi = new ProfileTemplateGuidanceConfigurationApi()

export default {
  name: 'contractorTemplate',
  components: {
    TemplateForm,
  },
  data() {
    return {
      rules: {},
      dialogShow: false,
      // 0 新增 1编辑 2详情
      pageType: 'create',
      tableLoading: false,
      dataList: [],
      totalCount: 0,
      searchData: {
        templateName: '',
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      FormData: {},
    }
  },
  created() {
    this.getList()
    this.initForm()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    // 新增-保存
    handleSave() {
      this.dialogShow = false
      this.getList()
    },
    // 初始化表单
    initForm() {
      this.FormData = {
        templateName: '',
        chooseList: [],
      }
    },
    // 新增
    handleAdd() {
      this.initForm()
      this.pageType = 'create'
      this.dialogShow = true
    },
    /**
     * 编辑、详情
     * @param {*} row 行信息
     * @param {*} type 1编辑 2详情
     */
    async handleEdit(row) {
      this.initForm()
      this.pageType = 'update'
      const [
        error,
        res,
      ] = await profileTemplateGuidanceConfigurationApi.profileTemplateGuidanceConfigurationList({
        templateId: row.id,
      })
      if (!error) {
        res.forEach((item) => {
          item.id = item.configurationId
        })
        this.FormData.chooseList = res
        this.$set(this.FormData, 'templateName', row.templateName)
        this.$set(this.FormData, 'id', row.id)
        this.dialogShow = true
      }
    },
    // 删除
    handleDel(row) {
      this.$confirm(`是否删除【${row.templateName}】`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await profileTemplateConfigurationApi.callDelete(row.id)
          if (!err) {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.getList()
          }
        })
        .catch(() => {})
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 页码改变
    tableSizeChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 获取消息列表
    async getList() {
      this.tableLoading = true
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      const [err, result] = await profileTemplateConfigurationApi.pagedListQuery(data)
      if (!err) {
        this.dataList = result.items || []
        this.totalCount = result.totalCount || 0
      }
      this.tableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
